module.exports = __webpack_public_path__ + "static/media/miraclesmission-light.101219ac.png";